/**
 * Types pour les Companies
 */

export type CompanyStatus = 'active' | 'inactive' | 'suspended';

export type CompanyType = 'prospect' | 'client';

export type CompanyScope = 'mine' | 'tenants' | 'all';

export interface Company {
  id: number;
  ownerCompanyId: number | null;
  name: string;
  siret: string | null;
  address: string | null;
  city: string | null;
  postalCode: string | null;
  country: string | null;
  phone: string | null;
  email: string | null;
  website: string | null;
  logoUrl: string | null;
  companyType: CompanyType;
  status: CompanyStatus;
  createdAt: string;
  updatedAt: string;
  opportunitiesCount?: number;
}

export interface CompanyStats {
  opportunitiesCount: number;
  wonCount: number;
  inProgressCount: number;
  totalEstimatedValue: number;
  lastOpportunityAt: string | null;
}

export interface CompanyFilters {
  search?: string;
  status?: CompanyStatus;
  companyType?: CompanyType;
  city?: string;
}

export interface PaginationParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface PaginationMeta {
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface PaginatedCompanies {
  data: Company[];
  meta: PaginationMeta;
}

export interface CreateCompanyDto {
  name: string;
  siret?: string;
  address?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  phone?: string;
  email?: string;
  website?: string;
  logoUrl?: string;
  companyType?: CompanyType;
}

export interface UpdateCompanyDto extends Partial<CreateCompanyDto> {
  status?: CompanyStatus;
}

/**
 * Configuration d'affichage des types de company
 */
export const COMPANY_TYPE_CONFIG: Record<
  CompanyType,
  { label: string; color: string; bgColor: string }
> = {
  prospect: {
    label: 'Prospect',
    color: 'text-amber-700',
    bgColor: 'bg-amber-100',
  },
  client: {
    label: 'Client',
    color: 'text-green-700',
    bgColor: 'bg-green-100',
  },
};

/**
 * Configuration d'affichage des statuts
 */
export const COMPANY_STATUS_CONFIG: Record<
  CompanyStatus,
  { label: string; color: string; bgColor: string }
> = {
  active: {
    label: 'Actif',
    color: 'text-green-700',
    bgColor: 'bg-green-100',
  },
  inactive: {
    label: 'Inactif',
    color: 'text-gray-700',
    bgColor: 'bg-gray-100',
  },
  suspended: {
    label: 'Suspendu',
    color: 'text-red-700',
    bgColor: 'bg-red-100',
  },
};
